import { jarallax } from 'jarallax';

export default function initJarallax() {
  jarallax(document.querySelectorAll('.js-jarallax'), {});
}